module.exports = __webpack_public_path__ + "img/facebook.7b4f963e.svg";